/**
 * Created by olga on 28.01.2025
 */

Match3TutorialHelper = {};

Match3TutorialHelper.createMoveStep = function (data) {
    const force = {
        text: data.textBlock.text || ""
    };

    if (data.control.length === 1) {
        force.finger = {
            tap: data.control
        };
    } else if (data.control.length === 2) {
        force.finger = {
            swipe: data.control
        };
    }

    const step = {
        onStart: function () {
            const field = Game.currentGame.field;

            this.cells = data.control.map((control) => field.getCell(control[0], control[1]));

            const activeNodes = [field.onGetView()];
            if (Game.currentGame.boosters.active) {
                activeNodes.push(Game.currentGame.boosters.onGetBoosterView(Game.currentGame.boosters.active.id));
            }

            this.force = cleverapps.forces.create(this.cells[0].onGetView(), force, {
                highlights: Match3TutorialHelper.getHighlights(),
                importantNodes: Match3TutorialHelper.getImportantNodes(data),
                highlightActives: false,
                actives: activeNodes
            });

            cleverapps.focusManager.showControlsWhileFocused(["field", "panel_controls", "panel_info"]);

            cleverapps.tutorial.on("move", this.finish.bind(this), this);
        },

        onFinish: function () {
            this.force.hideForceHints();
        }
    };

    return new TutorialStep(step);
};

Match3TutorialHelper.createBoosterActivationStep = function (data) {
    const force = {
        text: data.textBlock.text || ""
    };

    const step = {
        onStart: function () {
            const boosterView = Game.currentGame.boosters.onGetBoosterView(data.booster);
            this.force = cleverapps.forces.create(boosterView, force);

            this.booster = cleverapps.boosters.getBoosterById(data.booster);

            this.booster.setFreePrice();

            cleverapps.tutorial.on("boosterActivation", this.finish.bind(this), this);
        },

        onFinish: function () {
            this.force.hideForceHints();
            Game.currentGame.counter.trigger();
        }
    };

    return new TutorialStep(step);
};

Match3TutorialHelper.createBoosterCellStep = function (data) {
    const force = {
        text: data.textBlock.text || "",
        finger: false,
        closeByTouchInShadow: true
    };

    const step = {
        onStart: function () {
            Game.currentGame.shownBoosterCellTutorial = true;

            let boosterCell;

            Game.currentGame.field.iterateCells((cell) => {
                if (cell instanceof BoosterCell) {
                    boosterCell = cell;
                }
            });

            const completeStep = function () {
                this.finish();
                Game.currentGame.counter.trigger();
            }.bind(this);

            if (!boosterCell) {
                completeStep();
                return;
            }

            this.force = cleverapps.forces.create(boosterCell.onGetView(), force, {
                highlights: Match3TutorialHelper.getHighlights()
            });

            cleverapps.forces.onceForceClosed = completeStep;
        }
    };

    return new TutorialStep(step);
};

Match3TutorialHelper.getHighlights = function () {
    const game = Game.currentGame;
    const highlights = [cleverapps.Scenes.GetMovingNode()];

    if (game.field) {
        highlights.push(game.field.onGetView());
    }

    return highlights.filter(Boolean);
};

Match3TutorialHelper.getImportantNodes = function (data) {
    const game = Game.currentGame;
    const importantNodes = [];

    data = data || {};

    if (data.booster !== undefined) {
        importantNodes.push(game.boosters.onGetBoosterView(data.booster));
    }

    if (data.goals || data.goalsForce) {
        importantNodes.push(game.goals.onGetView());
    }

    if (data.importantCells) {
        data.importantCells.forEach((cellCoordinates) => {
            const cell = game.field.getCell(cellCoordinates[0], cellCoordinates[1]);
            const cellView = cell && cell.onGetView();
            if (cellView) {
                importantNodes.push(cellView);
            }
        });
    }

    return importantNodes.filter(Boolean);
};

Match3TutorialHelper.checkTutorialCell = function (cell) {
    const activeScenario = cleverapps.tutorial.getActive();
    const tutorialCells = activeScenario && activeScenario.getCurrentStep().cells;

    if (!tutorialCells) {
        return true;
    }

    return tutorialCells.some((tutorialCell) => cell.x === tutorialCell.x && cell.y === tutorialCell.y);
};